import { translate } from '../../src/i18n'

// todo: remove heading too
const Menu = [
  {
    heading: '',
    name: `${translate('patient.patients')}`,
    icon: 'fas fa-users',
    path: '/patients',
    translate: 'sidebar.nav.element.ELEMENTS',
    permissions:
      { suAccess: false,
       userAccess: true,
      adminAccess: true
    }
  },
  {
    heading: '',
    name: `${translate('device.devicesLabel')}`,
    icon: 'fas fa-tablet-alt',
    translate: 'sidebar.nav.element.ELEMENTS',
    path: '/devices',
    permissions:
      { suAccess: false,
       userAccess: true,
      adminAccess: true
    }

  },
  {
    heading: '',
    name: `${translate('billing.billings')}`,
    icon: 'fas fa-receipt',
    // path: "/billing",
    translate: 'sidebar.nav.element.ELEMENTS',
    permissions:
      { suAccess: false,
       userAccess: true,
      adminAccess: true
    },
    submenu: [
      {
        name: `${translate('billing.billingReportHeader')}`,
        path: '/billings',
        icon: 'fas fa-clipboard-list',
        translate: 'sidebar.nav.element.BUTTON',
      },
      {
        name: `${translate('billing.DetailedReportHeader')}`,
        path: '/detailed-reports',
        icon: 'fas fa-file-alt',
        translate: 'sidebar.nav.element.BUTTON',
      }
    ]
  },
  {
    name: `${translate('practices.practices')}`,
    icon: 'fas fa-clinic-medical',
    path: '/practices',
    // label: { value: 3, color: "success" },
    translate: 'sidebar.nav.element.ELEMENTS',
    permissions: {
      suAccess: true,
      userAccess: false,
      adminAccess: false
    }
  },
  {
    name: `${translate('users.practiceUsers')}`,
    icon: 'fas fa-user-friends',
    path: '/users',
    // label: { value: 3, color: "success" },
    translate: 'sidebar.nav.element.ELEMENTS',
    permissions:
      { suAccess: true,
       userAccess: false,
      adminAccess: true
    }
  },
  {
    name: `${translate('practices.practiceProfile')}`,
    icon: 'fas fa-clinic-medical',
    path: '/practices',
    isPracticeDetail: true,
    // label: { value: 3, color: "success" },
    translate: 'sidebar.nav.element.ELEMENTS',
    permissions: {
      suAccess: false,
      userAccess: true,
      adminAccess: true
    }
  }
]

export default Menu
